import type { AvailableSurveyApiItem } from '@/features/home/api/available-surveys-queries'
import type { CachedSignupSurveyCard } from './signupSurveyPrefs'

/** Maps a signup-survey card (API or cache) into the Home available-survey shape. */
export function mapSignupSurveyToAvailableItem(
  card: CachedSignupSurveyCard,
): AvailableSurveyApiItem {
  return {
    instrumentId: card.instrumentId,
    campaignId: card.campaignId,
    name: card.name,
    description: card.description,
    estimatedCompletionMinutes: card.estimatedCompletionMinutes,
    questionCount: card.questionCount,
    reward: {
      enabled: card.reward.enabled,
      amount: card.reward.amount,
      display: card.reward.display,
    },
    availableSlots: card.availableSlots,
    instrumentStatus: card.instrumentStatus,
    lastAnsweredQuestionId: card.lastAnsweredQuestionId,
    hasActiveSession: card.hasActiveSession,
    activeResponseId: card.activeResponseId,
  }
}

/**
 * Home survey merge rules:
 * - Signup owed → show **only** the signup card (hide all other available surveys).
 * - Signup null/completed → show available list; optionally hide signup id after submit.
 */
export function mergeHomeSurveys(
  available: AvailableSurveyApiItem[],
  signup: AvailableSurveyApiItem | null,
  hideInstrumentId?: string | null,
): AvailableSurveyApiItem[] {
  if (signup) return [signup]
  const base = hideInstrumentId
    ? available.filter((s) => s.instrumentId !== hideInstrumentId)
    : available
  return base
}
